export default function () {
	return {
		progress: 'all',
		search: '',
		loading: false,
		selected_areas: {
			value: 'all'
		},
		webinar_status: null,
		webinar_is_online: false,
		selected_groups: {
			value:'all'
		},
		selected_tags: {
			value:'all'
		},
		webcast_lounge_template:''
	}
}
